import { c as _c } from "react/compiler-runtime";
import { $React } from '@legendapp/state/react-web';
import { type DetailedHTMLProps, type HTMLAttributes } from 'react';
import { useLocationSelectState } from '@/components/forms/fields/LocationSelect/LocationSelectContext';
import { ChevronDownIcon } from '@/components/icons/ChevronDownIcon';
import { cn } from '@/lib/cn';
export type ValueFieldProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
export function ValueField(t0) {
  const $ = _c(13);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  const state$ = useLocationSelectState();
  let t1;
  if ($[4] !== className || $[5] !== state$.variant) {
    t1 = () => {
      const horizontal = state$.variant.get() === "horizontal";
      return cn("value-field rounded-lg border border-base-content py-4 px-3.5 flex items-center h-16 bg-white justify-between input-focus-transition  group-has-checked/label:rounded-b-none  hover:group-not-has-checked/label:bg-primary-accent", {
        "group-has-checked/label:border-active": horizontal,
        "group-has-checked/label:rounded-b-lg": horizontal,
        "group-has-checked/label:[&_.value-field-chevron-icon]:-rotate-180": !horizontal,
        "group-has-checked/label:[&_.value-field-chevron-icon]:-rotate-90": horizontal
      }, className);
    };
    $[4] = className;
    $[5] = state$.variant;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("value-field-chevron flex ml-auto items-center p-2 rounded-full input-focus-transition bg-base-150 group-has-checked/label:bg-primary group-has-checked/label:text-white");
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={t2} role="presentation"><div className="value-field-chevron-icon transition-[rotate]" aria-hidden="true"><ChevronDownIcon /></div></div>;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== children || $[10] !== props || $[11] !== t1) {
    t4 = <$React.div $className={t1} {...props}>{children}{t3}</$React.div>;
    $[9] = children;
    $[10] = props;
    $[11] = t1;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}